import Toastify from 'toastify-js'

const showToastify = (message, opts) => {
	Toastify({
		duration: 3000,
		position: "center",
		style: { background: "rgba(255, 255, 255, 1)", color: "rgba(2, 25, 44, 1)" },
		text: message,
		...opts
	}).showToast();
}

export default showToastify